import lawExamService from '@/service/law-exam'
import lawExamParseFunc from '@/service/law-exam/parseFunc'

export default {
  inject: ['companyParams', 'companyId'],
  data () {
    return {
      queryQA: {
        title: '问卷记录',
        showTotal: false,
        isQuestion: true,
        props: [
          { label: '问题', prop: 'question', className: 'table-highlight-row' },
          { label: '答案', prop: 'answer' }
        ]
      }
    }
  },
  mounted () {
    if (this.typeTables && Array.isArray(this.typeTables)) {
      this.initData()
      this.fetchData()
    }
  },
  methods: {
    initData () {
      let common = {
        total: 0,
        pageIndex: 1,
        pageSize: 10,
        entities: [],
        loading: false,
        showTotal: true,
        loadFinished: false
      }
      Object.entries(common).forEach(([key, value]) => {
        this.typeTables.forEach(table => {
          this.$set(table.source, key, value)
        })
      })
    },
    fetchData () {
      this.typeTables.forEach(table => {
        this.requestInfo(1, table)
      })
    },
    tablePageChanged (page, table) {
      let source = table.source
      if (source.pageHand && source.entities.length === source.total) {
        source.pageIndex = page
        return
      }
      this.requestInfo(page, table)
    },
    requestInfo (page, table) {
      let source = table.source
      let path = table.key
      source.loading = true
      let params = { pageIndex: page, pageSize: source.pageSize, name: this.companyParams.name }
      if (table.key === 'queryQA') {
        params = { type: table.source.type }
      }
      lawExamService.reportRequestInfo(path, this.companyId, params).then(res => {
        if (path === 'queryQA') {
          this.parseQueryQA(res, source)
        } else {
          this.parseData(path, res, source, page)
        }
      }).catch(_ => {
        source.loading = false
      })
    },
    parseData (path, res, source, page) {
      let func = lawExamParseFunc[path]
      Object.assign(source, lawExamService.parseData(res, source, page, func))
    },
    parseQueryQA (res, source) {
      source.loading = false
      source.entities = lawExamService.parseQAData(res)
    }
  }
}
